<template>
    <div class="">
        <h1 class="center py-4 web-only">Event Care</h1>
        <h1 class="center py-3 mobile-only">Event Care</h1>
        <div
        class="iframe-container"
        style="background-color: #1f4e78;"
        >
        <iframe
            width="100%"
            height="2000"
            src="https://www.youtube.com/embed/XsA9hY39Mjo?si=3avUY18l2c6U2gys"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="border-radius: 0.5%"
        ></iframe>
        </div>
    </div>
  </template>

  <script>
  export default {
    created() {
      // Scroll the window to top on load
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
  };
  </script>
  
  <style>
  /* https://www.youtube.com/watch?v=9YffrCViTVk&ab_channel=tipswithpunch */
  .iframe-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
  }
  .iframe-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  </style>


// WEBPACK FOOTER //
// src/components/communityconversations/EventCare.vue